import React, { useState } from 'react';
import { PscPhrase } from '../psc-phrase';

const ErrorMessage = ({ error }) => {
    const dupKeyMapping = {
        name: "Name",
        project_code: "Code",
        typecode_group_mapping_name: "Name",
        users_username: "Email",
        "name-code": "Code and Name"
    }

    const mapErrorMessage = function(msg) {
        let dbConstraintError = /Error 1452.*?Cannot add or update a child row/.exec(msg)
        let duplicate = /Duplicate entry.*?for key \'([\w\-]+)\'/.exec(msg);

        if( msg.match(/ENOACCESS/) ) {
            return PscPhrase('ERROR_MESSAGE_NOACCESS')
        }
        if( dbConstraintError || msg.match(/ECONFLICT/) ) {
            return `
                Another user has recently made changes affecting this page.
                You need to update this page before you can make changes.
                <a class="alert-link" onClick="window.location.reload()"> Click here to update.</a>
            `
        }
        if( msg.match(/EDUPLICATENAME/) ) {
            return PscPhrase('ERROR_MESSAGE_DUPLICATE_NAME')
        }
        if( msg.match(/EBADEMAIL/) ) {
            return PscPhrase('ERROR_MESSAGE_EMAIL')
        }
        if( msg.match(/EALREADYINCLUDED/) ) {
            return PscPhrase('ERROR_MESSAGE_ALREADY_INCLUDED')
        }
        
        if (duplicate) {
            let key = duplicate[1]
            if( dupKeyMapping[key] ) {
                key = dupKeyMapping[key]
            }
            return 'The given ' + key + ' already exists';
        }
        return msg
    }

    return (
        <div>
            {error && error.map(function(msg, index) {
                 return (
                     <div key={index} className="error-message alert alert-danger" dangerouslySetInnerHTML={{__html: mapErrorMessage(msg)}}></div>
                 )
             })}
        </div>
    )
}

export default ErrorMessage
